import r from "styled-components";
import { VisuallyHidden as i } from "../VisuallyHidden/VisuallyHidden.js";
import t from "../../utils/colors.js";
import { t as a } from "../../styled-qu50FBLM.mjs";
const n = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0yMCA2TDkgMTdsLTUtNSIvPjwvc3ZnPg==", e = {
  default: {
    backgroundColor: "transparent",
    color: "initial",
    padding: "0 0 15px 0",
    iconWidth: "16px"
  },
  confirmation: {
    backgroundColor: t.blueGrey10,
    color: t.blueGrey,
    padding: "20px",
    iconWidth: "16px",
    marginBottom: "15px"
  }
}, s = r.div`
  padding: ${(o) => e[o.$checkboxType].padding};
  width: ${(o) => o.$width};
  background-color: ${(o) => e[o.$checkboxType].backgroundColor};
  color: ${(o) => e[o.$checkboxType].color};
  ${(o) => o.$checkboxType === "confirmation" && `margin-bottom: ${e[o.$checkboxType].marginBottom}`};
`, h = r.div`
  display: block;
  width: 100%;
`, c = r(i).attrs({ as: "input" })``, $ = r.label`
  display: inline-block;
  position: relative;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  cursor: pointer;
  color: ${t.blueGrey};
  padding-left: calc(${(o) => e[o.$checkboxType].iconWidth} + calc(${(o) => e[o.$checkboxType].iconWidth} * 0.75));
  // text-indent a negative value equal to the sum of margin-left and padding-left properties
  text-indent: calc(calc(${(o) => e[o.$checkboxType].iconWidth} + calc(${(o) => e[o.$checkboxType].iconWidth} * 0.75)) * -1);

  /* Focus and Hover state */
  &:hover {
    ${a};
  }

  /* Disabled state */
  ${c}[disabled] + & {
    cursor: not-allowed;
    pointer-events: none;
  }

  &::before {
    content: '';
    display: inline-block;
    margin-right: calc(${(o) => e[o.$checkboxType].iconWidth} * 0.75);
    height: ${(o) => e[o.$checkboxType].iconWidth};
    width: ${(o) => e[o.$checkboxType].iconWidth};
    vertical-align: middle;
    background-color: ${t.white};
    border: 1px solid ${t.blueGrey};
  }
  &::after {
    content: '';
    position: absolute;
    opacity: 0;
    background-image: url(${n});
    background-repeat: no-repeat;
    height: ${(o) => e[o.$checkboxType].iconWidth};
    width: ${(o) => e[o.$checkboxType].iconWidth};
    left: 1px;
    top: 5px;
  }

  /* Checked state */
  ${c}:checked + &::before {
    background-color: ${t.orange};
    border-color: ${t.orange};
  }
  ${c}:checked:not([disabled]) + &::after {
    opacity: 1;
  }

  /* Error state */
  ${c}[aria-invalid='true']:not(:checked):not([disabled]) + &::before {
    border-color: ${t.red};
  }

  /* Disabled state */
  ${c}[disabled] + &::before {
    background-color: ${t.darkGrey10};
    border-color: ${t.darkGrey75};
  }

  /* Focus state */
  ${c}:focus + & {
    outline: 2px solid ${t.blueGrey25};
    outline-offset: 4px;
  }
  ${c}:focus + &::before,
  ${c}:hover + &::before {
    border-color: ${t.orange};
  }
`;
export {
  c as InputCheckbox,
  $ as Label,
  h as LabelWrapper,
  s as Wrapper,
  e as checkboxStyles
};
